import apiClient from './client';

export interface SupportedLanguage {
    id: number;
    code: string;
    name: string;
    native_name: string;
    is_active: boolean;
    // False for native-only languages (selectable as native language, not
    // learnable). Missing from older API responses — treat as learnable.
    learnable?: boolean;
}

/** Whether a language can be offered as a learning language. */
export const isLearnable = (lang: SupportedLanguage): boolean => lang.learnable !== false;

export interface GlobalSetting {
    id: number;
    key: string;
    value: any; // Can store JSON objects, arrays, or primitive values
    is_active: boolean;
    created_at: string;
    updated_at: string;
}

export const globalSettingService = {
    // Get Supported Languages
    getSupportedLanguages: async (): Promise<SupportedLanguage[]> => {
        const response = await apiClient.get('/api/v1/languages');
        return response.data;
    },

    // Get Global Settings - returns settings with JSON object values
    getGlobalSettings: async (): Promise<GlobalSetting[]> => {
        const response = await apiClient.get('/api/v1/globalsettings');
        return response.data;
    },
};